import axios from "axios";
import {
  show_adders_costs_specific_cards,
  create_adders_costs_specific_cards,
} from "../../../Api/Api";

const showAddersCostCard = async (data) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "GET",
    baseURL: `${show_adders_costs_specific_cards}/${data.id}`,
    headers: headers,
    // params: {
    //   type: data.type,
    // },
    // data: data,
  });
  return response.data;
};

const UpdateAddersCostSpecificCards = async (data) => {
  const { token } = JSON.parse(localStorage.getItem("user"));
  const headers = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  const response = await axios({
    method: "POST",
    baseURL: `${create_adders_costs_specific_cards}/${data.id}`,
    headers: headers,
    data: data,
  });
  return response.data;
};

const AddersCostCardService = {
  showAddersCostCard,
  UpdateAddersCostSpecificCards,
};
export default AddersCostCardService;
